/** Shared hero geometry. The bottom portion is reserved for the alpha fade. */
export const PROFILE_HERO_HEIGHT = 320;
export const PROFILE_HERO_CONTENT_PADDING = 16;
export const PROFILE_HERO_CONTENT_BOTTOM = 32;
export const PROFILE_HERO_TITLE_SIZE = 34;

/** Alpha stops reveal any page background rather than fading to one color. */
export const PROFILE_HERO_MASK_LOCATIONS = [
  0, 0.42, 0.58, 0.72, 0.86, 0.96, 1,
] as const;
